var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApDetectionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a",
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(3 1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.363,12.162H32.98c-.6-4.126-5.444-7.662-10.8-7.662h0C16.388,4.5,10.252,8.878,9.993,21H9.3a.806.806,0,0,0-.864.842v2.694H8.264a.806.806,0,0,0-.864.842v5.3a.806.806,0,0,0,.864.842h5.444a.806.806,0,0,0,.864-.842v-5.3a.806.806,0,0,0-.864-.842h-.173V21.845A.806.806,0,0,0,12.672,21h-.778c.259-9.262,4.062-14.819,10.457-14.819h0c4.407,0,8.383,2.779,8.988,5.978H22.264a2.72,2.72,0,0,0-2.938,2.526v9.683a2.437,2.437,0,0,0,1.123,1.937,1.87,1.87,0,0,1,.864,1.516l.864,8.5A2.76,2.76,0,0,0,25.116,38.6h6.568a2.769,2.769,0,0,0,2.938-2.273l.864-8.588a1.729,1.729,0,0,1,.864-1.431,2.321,2.321,0,0,0,1.123-1.937V14.688A2.888,2.888,0,0,0,34.363,12.162ZM12.672,26.139h.173v3.621H9.128V26.139H9.3a.806.806,0,0,0,.864-.842V22.6h1.556V25.3A.933.933,0,0,0,12.672,26.139Zm22.988-1.768a.569.569,0,0,1-.346.505,3.34,3.34,0,0,0-1.642,2.779l-.864,8.5a1.182,1.182,0,0,1-1.21.758H25.03c-.6,0-1.21-.337-1.21-.758l-.864-8.42a3.478,3.478,0,0,0-1.642-2.863c-.086-.084-.346-.253-.346-.505V14.688c0-.421.6-.842,1.21-.842H34.363c.691,0,1.21.421,1.21.842v9.683Z",
    transform: "translate(-7.4 -4.5)",
    stroke: "#fff",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.325,17.2h-9.16a.816.816,0,0,0-.864.864V25.41a.816.816,0,0,0,.864.864h9.247a.816.816,0,0,0,.864-.864V18.064A.942.942,0,0,0,35.325,17.2Zm-.864,7.346H26.942V18.928H34.46Z",
    transform: "translate(-9.831 -6.606)",
    stroke: "#fff",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.664,23.028h3.025a.864.864,0,1,0,0-1.728H29.664a.816.816,0,0,0-.864.864A.866.866,0,0,0,29.664,23.028Z",
    transform: "translate(-10.306 -7.174)",
    stroke: "#fff",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.46,30.7h-1.3a.864.864,0,1,0,0,1.728h1.3a.816.816,0,0,0,.864-.864A.866.866,0,0,0,29.46,30.7Z",
    transform: "translate(-10.102 -8.67)",
    stroke: "#fff",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.56,30.7h-1.3a.864.864,0,1,0,0,1.728h1.3a.816.816,0,0,0,.864-.864A.866.866,0,0,0,34.56,30.7Z",
    transform: "translate(-10.795 -8.67)",
    stroke: "#fff",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.56,34.6h-1.3a.864.864,0,1,0,0,1.728h1.3a.816.816,0,0,0,.864-.864A.866.866,0,0,0,34.56,34.6Z",
    transform: "translate(-10.795 -9.291)",
    stroke: "#fff",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.56,38.4h-1.3a.864.864,0,1,0,0,1.728h1.3a.816.816,0,0,0,.864-.864A.866.866,0,0,0,34.56,38.4Z",
    transform: "translate(-10.795 -10.004)",
    stroke: "#fff",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.46,38.4h-1.3a.864.864,0,0,0,0,1.728h1.3a.816.816,0,0,0,.864-.864A.866.866,0,0,0,29.46,38.4Z",
    transform: "translate(-10.102 -10.004)",
    stroke: "#fff",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.46,34.6h-1.3a.864.864,0,0,0,0,1.728h1.3a.816.816,0,0,0,.864-.864A.866.866,0,0,0,29.46,34.6Z",
    transform: "translate(-10.102 -9.291)",
    stroke: "#fff",
    strokeWidth: 0.6
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApDetectionIcon);
export default __webpack_public_path__ + "static/media/ap-detection-icon.ba2edfd5d95ba99b363deebf494ff953.svg";
export { ForwardRef as ReactComponent };